import styled from 'styled-components/macro';

export const Title = styled.p`
  font-size: 12px;
  margin-bottom: 6px;
`;
